/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MailboxItemRecipientType = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;
export type MailboxItemRecipientType = typeof MailboxItemRecipientType[keyof typeof MailboxItemRecipientType];


export function instanceOfMailboxItemRecipientType(value: any): boolean {
    for (const key in MailboxItemRecipientType) {
        if (Object.prototype.hasOwnProperty.call(MailboxItemRecipientType, key)) {
            if (MailboxItemRecipientType[key as keyof typeof MailboxItemRecipientType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MailboxItemRecipientTypeFromJSON(json: any): MailboxItemRecipientType {
    return MailboxItemRecipientTypeFromJSONTyped(json, false);
}

export function MailboxItemRecipientTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxItemRecipientType {
    return json as MailboxItemRecipientType;
}

export function MailboxItemRecipientTypeToJSON(value?: MailboxItemRecipientType | null): any {
    return value as any;
}

export function MailboxItemRecipientTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): MailboxItemRecipientType {
    return value as MailboxItemRecipientType;
}

